module.exports = __webpack_public_path__ + "static/media/bg_note_payment.948979f8.jpg";